const TOKEN_NAME = 'bearer-token';
const LANDLORD_TOKEN_NAME = 'landlord-bearer-token';
const REFRESH_TOKEN_NAME = 'landlord-refresh-token';
const TENANT_REFRESH_TOKEN_NAME = 'tenant-refresh-token';
const BEARER_TOKEN_AGE = 60 * 15;
const REFRESH_TOKEN_AGE = 60 * 60 * 24 * 30;
const EXPIRY_SKEW_SECONDS = 30;

const writeToken = (key: string, value?: string, age: number = BEARER_TOKEN_AGE) => {
  if (value) {
    localStorage.setItem(key, JSON.stringify({ token: value, expiresAt: Date.now() + age * 1000 }));
  } else {
    localStorage.removeItem(key);
  }
};

const readToken = (key: string): string => {
  try {
    const item = localStorage.getItem(key);
    if (!item) return '';

    const { token, expiresAt } = JSON.parse(item);

    if (Date.now() > expiresAt) {
      localStorage.removeItem(key);
      return '';
    }

    return token as string;
  } catch {
    return '';
  }
};

const readTokenExpiry = (key: string): number | null => {
  try {
    const item = localStorage.getItem(key);
    if (!item) return null;

    const { expiresAt } = JSON.parse(item);

    return typeof expiresAt === 'number' ? expiresAt : null;
  } catch {
    return null;
  }
};

const bearerTokenAge = (expiresInMinutes?: number) =>
  expiresInMinutes ? Math.max(1, expiresInMinutes * 60 - EXPIRY_SKEW_SECONDS) : BEARER_TOKEN_AGE;

export const setBearerToken = (value?: string, expiresInMinutes?: number) =>
  writeToken(TOKEN_NAME, value, bearerTokenAge(expiresInMinutes));
export const getBearerToken = () => readToken(TOKEN_NAME);
export const getBearerTokenExpiresAt = () => readTokenExpiry(TOKEN_NAME);

export const setLandlordBearerToken = (value?: string, expiresInMinutes?: number) =>
  writeToken(LANDLORD_TOKEN_NAME, value, bearerTokenAge(expiresInMinutes));
export const getLandlordBearerToken = () => readToken(LANDLORD_TOKEN_NAME);
export const getLandlordBearerTokenExpiresAt = () => readTokenExpiry(LANDLORD_TOKEN_NAME);

export const setRefreshToken = (value?: string, ttlMinutes?: number) =>
  writeToken(REFRESH_TOKEN_NAME, value, ttlMinutes ? ttlMinutes * 60 : REFRESH_TOKEN_AGE);
export const getRefreshToken = () => readToken(REFRESH_TOKEN_NAME);

export const setTenantRefreshToken = (value?: string, ttlMinutes?: number) =>
  writeToken(TENANT_REFRESH_TOKEN_NAME, value, ttlMinutes ? ttlMinutes * 60 : REFRESH_TOKEN_AGE);
export const getTenantRefreshToken = () => readToken(TENANT_REFRESH_TOKEN_NAME);

export const setBearerTokenCookie = (value?: string) => {
  if (value) {
    document.cookie = `${TOKEN_NAME}=${encodeURIComponent(value)}; SameSite=None; Secure; Path=/; Max-Age=${BEARER_TOKEN_AGE}`;
  } else {
    document.cookie = `${TOKEN_NAME}=; SameSite=None; Secure; Path=/; Max-Age=0`;
  }
};
